export class CreateBatchDTO{
    id:string;
    batchID: string;
    labID: string;
    workFlow: string;
    sampleType: string;
    dueDate: Date = new Date();
    projectID: string;
    projectName: string;
    priority = 10;
    plates: string[] = [];
    version?:number;
    type:string;
    isBatchCreatedAtAStartStep = true;
}
